var map = {
	"./accounting/coa-category.js": "327b",
	"./accounting/coa-mapping.js": "6d29",
	"./accounting/coa-setup.js": "814a",
	"./accounting/journal-entry.js": "99d3d",
	"./booking/available-schedule.js": "7ba1",
	"./booking/table-booking.js": "f69f",
	"./booking/table-profile.js": "1b4b",
	"./corporate/address.js": "28e6",
	"./corporate/bank-profile.js": "353d",
	"./corporate/branch.js": "39e0",
	"./corporate/company.js": "052b",
	"./counter/setup.js": "8f8d",
	"./customer/dealer-grade.js": "8785",
	"./customer/location-visitation.js": "a681",
	"./customer/profile.js": "f49e",
	"./customer/visitation.js": "4cf5",
	"./dashboard/widget.js": "df22",
	"./employee/department.js": "d8bc",
	"./employee/position.js": "dc0a",
	"./employee/profile.js": "ae63",
	"./exchange-rate/currency-rate.js": "402c",
	"./exchange-rate/currency.js": "c8a6",
	"./expense/daily-cash-advance.js": "1b28",
	"./expense/daily-expense.js": "da50",
	"./expense/expense-category.js": "6453",
	"./expense/expense-item.js": "ddc62",
	"./expense/expense-posting.js": "1d74",
	"./hr/approval-request.js": "c6ff",
	"./human-resource/attendance-device.js": "74dd",
	"./human-resource/basic-salary-formula.js": "0451",
	"./human-resource/basic-salary.js": "b7c5",
	"./human-resource/daily-attendance.js": "e729",
	"./human-resource/employee.js": "e114",
	"./human-resource/holiday-rule.js": "3bd4",
	"./human-resource/holiday.js": "0f76",
	"./human-resource/job-detail.js": "fa76",
	"./human-resource/job-level.js": "4ae5",
	"./human-resource/job-title.js": "9683",
	"./human-resource/leave-initial-balance.js": "9017",
	"./human-resource/leave-record.js": "bac5",
	"./human-resource/leave-rule.js": "dcd4",
	"./human-resource/leave-sub-item.js": "3063",
	"./human-resource/nationality.js": "d98b",
	"./human-resource/organizational-chart.js": "7d17",
	"./human-resource/organizational-structure.js": "c1e6",
	"./human-resource/position-hierarchy.js": "a23b",
	"./human-resource/shift-management.js": "063f",
	"./human-resource/work-schedule.js": "c1e6e",
	"./index.js": "2a74",
	"./mart-sale/order.js": "7528",
	"./payroll/first-cycle-paid.js": "0eb9",
	"./payroll/fixed-allowance.js": "0c87",
	"./payroll/fixed-incentive-bonus.js": "7ae5",
	"./payroll/item-allowance.js": "50d3",
	"./payroll/item-compensate.js": "d3d3",
	"./payroll/item-deduction.js": "37f4",
	"./payroll/item-incentive-bonus.js": "d4f3",
	"./payroll/item-overtime.js": "68f3",
	"./payroll/monthly-allowance.js": "abb3",
	"./payroll/monthly-compensate.js": "ad1c",
	"./payroll/monthly-deduction.js": "46d0",
	"./payroll/monthly-incentive-bonus.js": "5c52",
	"./payroll/monthly-overtime.js": "69c4",
	"./payroll/overtime-rule-by-shift.js": "bd920",
	"./payroll/pay-user-variable.js": "4e8d",
	"./payroll/payroll-calculation.js": "6a9a",
	"./payroll/payroll-cycle-date.js": "664b",
	"./payroll/payroll-cycle.js": "bae9",
	"./payroll/payroll-template.js": "7f95",
	"./payroll/payslip-template.js": "8b35",
	"./payroll/tax-range.js": "3369",
	"./pending-confirmation/pending-confirmation.js": "dc48",
	"./product/add-on.js": "294f",
	"./product/assembly.js": "17ad",
	"./product/cost.js": "a720",
	"./product/group.js": "f2dd",
	"./product/history.js": "68c4",
	"./product/label.js": "9e00",
	"./product/location.js": "db47",
	"./product/pallet.js": "2f2c",
	"./product/price.js": "d4e0",
	"./product/product-category.js": "9570",
	"./product/profile.js": "d749",
	"./product/specification.js": "56ae",
	"./product/uom-category.js": "9937",
	"./project-mgt/home.js": "8810",
	"./project-mgt/operation.js": "507a",
	"./project-mgt/project-milestone.js": "e0da",
	"./project-mgt/project-profile.js": "1567",
	"./project-mgt/site-profile.js": "1760",
	"./project-mgt/sub-task-profile.js": "4456",
	"./project-mgt/task-profile.js": "f1fa",
	"./promotion/buy-item-free-item.js": "b0d8",
	"./promotion/discount.js": "6b8a",
	"./promotion/free-coin-per-amount.js": "775e",
	"./promotion/free-item-per-amount.js": "06de",
	"./promotion/resource.js": "8b86",
	"./purchase-order/order.js": "1591",
	"./purchase-order/purchase-type.js": "8cdb",
	"./purchase-request/purchase-request.js": "f467",
	"./report/accounting.js": "258a",
	"./report/attendance-detail.js": "484c",
	"./report/attendance-gallery.js": "f1d8",
	"./report/attendance-summary.js": "2ca8",
	"./report/basic-salary-history.js": "0df1",
	"./report/daily.js": "47ff",
	"./report/employee-profile.js": "7dda",
	"./report/expense.js": "393a",
	"./report/finance.js": "d6de",
	"./report/inventory-list-by-warehouse.js": "3944",
	"./report/inventory.js": "fdb5",
	"./report/leave-report.js": "2f31",
	"./report/nssf-report.js": "ac3f",
	"./report/payroll-detail.js": "7976",
	"./report/payslip.js": "9b3f",
	"./report/product-addon-info-not-assign.js": "19a4",
	"./report/product-addon-info.js": "55f5",
	"./report/project.js": "4930",
	"./report/resource.js": "0378",
	"./report/sale.js": "7f53",
	"./report/summary-pension-and-insurance.js": "73b6",
	"./report/transection-back-date.js": "c625",
	"./restaurant-sale/counter-checkout.js": "d350",
	"./restaurant-sale/customer-display-order.js": "a3bd",
	"./restaurant-sale/customer-order.js": "12b6",
	"./restaurant-sale/kdu.js": "7bed",
	"./restaurant-sale/kot-bot-printer.js": "ae44",
	"./restaurant-sale/product-price-schema.js": "ebdb",
	"./restaurant-sale/sale-product-deleted.js": "527c",
	"./sale/sale-area.js": "09ee",
	"./security/customer-user.js": "269b",
	"./security/login-out.js": "76bf",
	"./security/role.js": "168c",
	"./security/user-permission-report.js": "349c",
	"./security/user.js": "8e74",
	"./service-management/home.js": "71aa",
	"./service-management/service-request.js": "40e4",
	"./setting/approval-request-flow.js": "6543",
	"./setting/sys-setting.js": "1c65",
	"./stock/adjustment.js": "e8cc",
	"./stock/inventory-list.js": "8143",
	"./stock/return-from-vendor.js": "8ba2",
	"./stock/return-to-vendor.js": "65a3",
	"./stock/stock-close.js": "29c2",
	"./stock/stock-count.js": "617d",
	"./stock/stock-in-confirm.js": "ede3",
	"./stock/stock-in.js": "54e4",
	"./stock/stock-return.js": "68b6",
	"./stock/stock-transfer.js": "337f",
	"./stock/transfer-by-serial.js": "32d0",
	"./stock/warehourse.js": "c177",
	"./stock/write-off-confirm.js": "ffc4",
	"./stock/write-off.js": "6904",
	"./supplier/payment.js": "663f",
	"./supplier/profile.js": "783b",
	"./wholesale/borrowing-spare-part.js": "ca8a",
	"./wholesale/delivery-order.js": "8224",
	"./wholesale/operation.js": "0db1",
	"./wholesale/quotation.js": "acc0",
	"./wholesale/receipt.js": "9d95",
	"./wholesale/replacement.js": "53f4",
	"./wholesale/sale-contract.js": "e4f1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0308";